import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the divisionsImport state domain
 */

const selectDivisionsImportDomain = (state) =>
  state.get("divisionsImport", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsDownloading = () =>
  createSelector(selectDivisionsImportDomain, (state) =>
    state.get("isDownloading")
  )

export const makeSelectIsUploading = () =>
  createSelector(selectDivisionsImportDomain, (state) =>
    state.get("isUploading")
  )
/**
 * Default selector used by DivisionsImport
 */

const makeSelectDivisionsImport = () =>
  createSelector(selectDivisionsImportDomain, (substate) => substate.toJS())

export default makeSelectDivisionsImport
export { selectDivisionsImportDomain }
